import { ICustomer } from '../../model/customer.model';

export const initialState: ICustomer = {
  civility: '',
  birthday: null,
  firstName: '',
  lastName: '',
  cityOfBirth: '',
  streetNumber: '',
  address: '',
  email: '',
  confirmEmail: '',
  additionalAddress: '',
  zipCode: null,
  city: '',
  phoneNumber: '',
  mobileNumber: '',
  country: 'FR',
  bankAccountOwner: '',
  iban: null,
  BIC: null,
  iso2countryOfBirth: 'FR',
  checkboxSign: false,
  legalRepresentative: '',
  legalRepresentativeTitle: '',
  siret: '',
  socialReason: ''
};

export type CustomerState = Readonly<typeof initialState>;
